var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6C6.67158 6 6 6.67158 6 7.5C6 8.32842 6.67158 9 7.5 9C8.32842 9 9 8.32842 9 7.5C9 6.67158 8.32842 6 7.5 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 2C3.67894 2 2 3.67894 2 5.75V10.7411C2 11.7357 2.3951 12.6895 3.09835 13.3927L10.6146 20.909C12.0791 22.3735 14.4534 22.3735 15.9179 20.909L20.909 15.9179C22.3735 14.4534 22.3735 12.0791 20.909 10.6146L13.3927 3.09835C12.6895 2.39509 11.7357 2 10.7411 2H5.75ZM3.5 5.75C3.5 4.50736 4.50736 3.5 5.75 3.5H10.7411C11.3379 3.5 11.9101 3.73705 12.3321 4.15901L19.8484 11.6752C20.7271 12.5539 20.7271 13.9786 19.8484 14.8573L14.8573 19.8484C13.9786 20.7271 12.5539 20.7271 11.6752 19.8484L4.15901 12.3321C3.73705 11.9101 3.5 11.3379 3.5 10.7411V5.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.baff7539fb043df2290b34de3302f316.svg";
export { ForwardRef as ReactComponent };